import { render, staticRenderFns } from "./SpaceVIcon.vue?vue&type=template&id=4e6f85dc&"
import script from "./SpaceVIcon.vue?vue&type=script&lang=js&"
export * from "./SpaceVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports